module.exports = {
  __init__: [ 'selectionVisuals', 'selectionBehavior' ],
  __depends__: [
    require(48),
    require(50)
  ],
  selection: [ 'type', require(53) ],
  selectionVisuals: [ 'type', require(55) ],
  selectionBehavior: [ 'type', require(54) ]
};
